import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_BACKUP_DELETE_POLL_DELAY,
  MDS_BACKUP_DELETE_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlDeleteBackupProps extends OperationConfirmationProps {
  backupId: string;
}

const MysqlDeleteBackup = (
  { location, backupId, onExecute }: MysqlDeleteBackupProps,
): JSX.Element => {
  const { invokeCall: invokeDelete } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.deleteMdsBackup },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(backupId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const backupKey = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.deleteBackup(),
          message: Messages.notifications.inProgress.messages.deleteBackup(backupKey),
        },
        success: {
          title: Messages.notifications.success.titles.deleteBackup(),
          message: Messages.notifications.success.messages.deleteBackup(backupKey),
        },
        failure: {
          title: Messages.notifications.failure.titles.delete(),
          message: Messages.notifications.failure.messages.deleteBackup(backupKey),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_BACKUP_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            backupKey,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_BACKUP_DELETED_CHECK,
          errorStatusOverrides: [404],
          delay: MDS_BACKUP_DELETE_POLL_DELAY,
          interval: MDS_BACKUP_DELETE_POLL_INTERVAL,
        },
      },
    };
    invokeDelete({
      subscriptionId,
      resourceGroupName,
      backupKey,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlDeleteBackup = (
  props: MysqlDeleteBackupProps,
): JSX.Element => (<MysqlDeleteBackup {...props} />);
